import styled from '@emotion/styled';

export const Overlay = styled.div`
  position: absolute;
  background: rgba(255, 255, 255, 0.4);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 300;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
`;
